export default __webpack_public_path__ + "static/NeonTubes2-Regular-273be1e051d4d5092d637221dfe730a5.woff2";